export default function drIdsHashed() {
  const doctor    = JSON.parse(localStorage.getItem('user'));
  const location  = JSON.parse(localStorage.getItem('practice_location'));
  return { doctor_id: doctor?.id, location_id: location?.id };
}